import { StyledLink } from "../utils/button";
import "../styles/verifyemail.css";
import { useSelector } from "react-redux";
import { selectUser, setTimeActive, timeActive } from "../services/userSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { auth, sendEmailVerification } from "../firebaseSetup";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const user = useSelector(selectUser);
  const timeAct = useSelector(timeActive);
  const [time, setTime] = useState(60);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      if (user?.emailVerified) {
        clearInterval(interval);
        navigate("/dashboard");
      }
    }, 1000);
  }, [navigate, user]);

  useEffect(() => {
    let interval: string | number | NodeJS.Timer | null | undefined = null;
    if (timeAct && time !== 0) {
      interval = setInterval(() => {
        setTime((time) => time - 1);
      }, 1000);
    } else if (time === 0) {
      dispatch(setTimeActive(false));
      setTime(60);
      clearInterval(interval!);
    }
    return () => clearInterval(interval!);
  }, [dispatch, time, timeAct]);

  const resendEmailVerification = () => {
    sendEmailVerification(auth.currentUser!)
      .then(() => {
        dispatch(setTimeActive(true));
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <main className="verify-email">
      <section>
        <h2>Verify your Email Address</h2>
        <p>
          A verification email has been sent to: <span>{user?.email}</span>
        </p>
        <p>Follow the instruction in the email to verify your account</p>

        <StyledLink
          as="button"
          disabled={timeAct}
          onClick={resendEmailVerification}
          style={{
            opacity: timeAct ? 0.7 : 1,
            cursor: timeAct ? "not-allowed" : "pointer",
          }}
        >
          Resend Email
        </StyledLink>
        <p>{time}</p>
      </section>
    </main>
  );
};

export default VerifyEmail;
